import React, { useState } from 'react';
import { submitForm } from '../utils/api';
import './FormPage.css';

// Create a simplified survey form component for testing
const Form = ({ formData, onSubmit }) => {
  const [satisfaction, setSatisfaction] = useState('');
  const [feedback, setFeedback] = useState('');
  const [email, setEmail] = useState('');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ satisfaction, feedback, email });
  };
  
  return (
    <div className="form-container">
      <h2>{formData.title || 'Survey Form'}</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-field">
          <label>How satisfied are you with our product?</label>
          <select
            value={satisfaction}
            onChange={(e) => setSatisfaction(e.target.value)}
            required
          >
            <option value="">Please select...</option>
            <option value="very-satisfied">Very Satisfied</option>
            <option value="satisfied">Satisfied</option>
            <option value="neutral">Neutral</option>
            <option value="dissatisfied">Dissatisfied</option>
            <option value="very-dissatisfied">Very Dissatisfied</option>
          </select>
        </div>
        <div className="form-field">
          <label>Do you have any additional feedback?</label>
          <textarea 
            value={feedback} 
            onChange={(e) => setFeedback(e.target.value)}
            rows={4}
          />
        </div>
        <div className="form-field">
          <label>Email (optional)</label>
          <input 
            type="email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

const SurveyFormPage = () => {
  const [apiEnvironment, setApiEnvironment] = useState('simulation');
  const [submissionResult, setSubmissionResult] = useState(null);
  
  const surveyFormData = {
    title: 'Customer Satisfaction Survey',
    description: 'We value your feedback!'
  };
  
  const handleSubmit = async (formValues) => {
    console.log('Survey form values:', formValues);
    
    try {
      // Submit to the selected API environment
      const result = await submitForm('survey', formValues, null, apiEnvironment);
      console.log('Submission result:', result);
      setSubmissionResult(result);
      return result;
    } catch (error) {
      console.error('Submission error:', error);
      setSubmissionResult({
        success: false,
        message: error.message || 'An unknown error occurred'
      });
      throw error;
    }
  };
  
  return (
    <div>
      <h1 className="page-title">Survey Form Example</h1>
      
      <div className="page-description">
        <p>This example showcases a customer satisfaction survey form with multiple question types. Surveys like this help gather valuable feedback to improve products and services.</p>
      </div>
      
      <div className="form-options">
        <div className="option-group">
          <label htmlFor="api-environment">API Environment:</label>
          <select
            id="api-environment"
            value={apiEnvironment}
            onChange={(e) => setApiEnvironment(e.target.value)}
          >
            <option value="simulation">Simulation (No API)</option>
            <option value="local">Local API (http://localhost:8787)</option>
            <option value="production">Production API</option>
          </select>
        </div>
      </div>
      
      {submissionResult && (
        <div className={`submission-result ${submissionResult.success ? 'success' : 'error'}`}>
          <h3>{submissionResult.success ? 'Submission Successful' : 'Submission Failed'}</h3>
          <p>{submissionResult.message}</p>
          {submissionResult.id && <p>Reference ID: {submissionResult.id}</p>}
        </div>
      )}
      
      <div className="form-container-wrapper">
        <Form
          formData={surveyFormData}
          onSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};

export default SurveyFormPage; 